import { render } from "./Holding.vue?vue&type=template&id=60b8c6fd&scoped=true"
import script from "./Holding.vue?vue&type=script&lang=js"
export * from "./Holding.vue?vue&type=script&lang=js"

import "./Holding.vue?vue&type=style&index=0&id=60b8c6fd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b8c6fd"]])

export default __exports__